export enum SolicitareType {
    Suport = 0,
    Urbanism = 1,
    DGITL = 2,
    AutorizariComerciale = 3,
    Programari = 5,
    DGASPC = 6,
}
